import {gql} from '@apollo/client';

export const SHORTEN_URL = gql`
	mutation ShortenUrl($url: String!) {
		shortenUrl(url: $url)
	}
`;
